export default __webpack_public_path__ + "static/hero-video-3-fd39307ecbca560d97dd86c2909445ab.mp4";